import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useThemeStore } from '@/store/theme/store';
import { ToastContainer } from 'react-toastify';

export default function ThemeWrapper({ children }: { children: React.ReactNode }) {
  const theme = useThemeStore((state) => state.theme);
  const location = useLocation();
  
  const isAuthPage = location.pathname.startsWith('/auth');

  useEffect(() => {
    if (!isAuthPage) {
      document.documentElement.classList.toggle('light-theme', theme === 'light');
    }
  }, [theme, isAuthPage]);

  return (
    <>
      {children}
      <ToastContainer theme={isAuthPage ? 'light' : theme} autoClose={30000} />
    </>
  );
}
